import { render, staticRenderFns } from "./DayTrade.vue?vue&type=template&id=c0275872&scoped=true"
import script from "./DayTrade.vue?vue&type=script&lang=ts&setup=true"
export * from "./DayTrade.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DayTrade.vue?vue&type=style&index=0&id=c0275872&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0275872",
  null
  
)

export default component.exports